export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Vest_BaseColor.054eb1c4.tga";